import { Injectable } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
    InstallationMaalerAflaesningMedMaalerType,
    InstallationMaalerAflaesningService,
    MaalerType,
    MaalerTypeRepository
} from "@e-forsyning/common/maaler";

import { FeatureMaalerAflaesningViewModel } from "../model/feature-maaler-aflaesning.view-model";
import { MaalerAflaesningIndstillinger } from "../model/maaler-aflaesning-indstillinger.model";
import { FeatureMaalerAflaesningMailService } from "./feature-maaler-aflaesning-mail.service";
import { FeatureMaalerAflaesningFormBuilder } from "./feature-maaler-aflaesning.form-builder";
import { FeatureMaalerAflaesningRepository } from "./feature-maaler-aflaesning.repository";

@Injectable({ providedIn: "root" })
export class FeatureMaalerAflaesningService {
    constructor(
        private readonly repository: FeatureMaalerAflaesningRepository,
        private readonly maalerTypeRepository: MaalerTypeRepository,
        private readonly mailService: FeatureMaalerAflaesningMailService,
        private readonly installationMaalerAflaesningService: InstallationMaalerAflaesningService
    ) {}

    public hentData(): Observable<FeatureMaalerAflaesningViewModel> {
        const maalerAflaesning$ = this.hentMaalerAflaesning();
        const indstillinger$ = this.hentIndstillinger();
        return combineLatest([maalerAflaesning$, indstillinger$]).pipe(
            map(([maalerAflaesning, indstillinger]) => {
                const formGroup = FeatureMaalerAflaesningFormBuilder.maalerAflaesningToFormGroup(maalerAflaesning);
                const sideTitel = indstillinger.sideTitel;
                return { formGroup, sideTitel };
            })
        );
    }

    public hentMaalerAflaesning(): Observable<InstallationMaalerAflaesningMedMaalerType> {
        return this.installationMaalerAflaesningService.hentMaalerAflaesningForAktuelleInstallation();
    }

    public hentIndstillinger(): Observable<MaalerAflaesningIndstillinger> {
        return this.repository.hentIndstillinger();
    }

    public hentMaalerTyper(): Observable<MaalerType[]> {
        return this.maalerTypeRepository.hentMaalerTyper();
    }

    public async gemMaalerAflaesning(formGroup: UntypedFormGroup): Promise<void> {
        const { maalerAflaesning } = FeatureMaalerAflaesningFormBuilder.formGroupToMaalerAflaesning(formGroup);
        await this.installationMaalerAflaesningService.gemMaalerAflaesning(maalerAflaesning);
    }

    public async sendMailKvittering(formGroup: UntypedFormGroup): Promise<void> {
        const { maalerAflaesning, email } = FeatureMaalerAflaesningFormBuilder.formGroupToMaalerAflaesning(formGroup);
        await this.mailService.sendMail(maalerAflaesning, email);
    }
}
